import type { RectangleElement } from '@/components/canvas/document/publicTypes';
import { resolveCornerRadiiPx } from '@/components/canvas/shared/utils/geometry/cornerRadius';
import { elementFillCss, firstShadow, firstStroke } from '@/components/canvas/elements/model';
import { roundedRectPath } from '@/components/canvas/rendering/export/roundedRect';
import { drawShapeText } from '../utils/shapeTextExport';

export async function drawRect(ctx: CanvasRenderingContext2D, el: RectangleElement) {
  const { x, y } = el.layout;
  const { width, height } = el.size;
  const fillColor = elementFillCss(el);
  const stroke = firstStroke(el.appearance);
  const shadow = firstShadow(el.appearance);

  if (shadow) {
    ctx.shadowBlur = shadow.blur;
    ctx.shadowColor = shadow.color;
    ctx.shadowOffsetX = shadow.offsetX;
    ctx.shadowOffsetY = shadow.offsetY;
  }

  const r = resolveCornerRadiiPx(el);
  const path = roundedRectPath(x, y, width, height, r);

  if (fillColor) {
    ctx.fillStyle = fillColor;
    ctx.fill(path);
  }

  ctx.shadowBlur = 0;
  ctx.shadowOffsetX = 0;
  ctx.shadowOffsetY = 0;

  if (stroke && stroke.width > 0 && stroke.color) {
    ctx.strokeStyle = stroke.color;
    ctx.lineWidth = stroke.width;
    if (stroke.style === 'dashed') ctx.setLineDash([stroke.width * 3, stroke.width * 2]);
    else if (stroke.style === 'dotted') ctx.setLineDash([stroke.width, stroke.width]);
    else ctx.setLineDash([]);
    ctx.stroke(path);
    ctx.setLineDash([]);
  }

  if (el.data.text) {
    drawShapeText(ctx, el, { x, y, width, height });
  }
}
